module.exports = __webpack_public_path__ + "5a2c6e0556656a59a4652644b3ef62d9.svg";